"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountDialogValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.accountDialogValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
});
//# sourceMappingURL=validation.js.map